import PropTypes from 'prop-types';
import { Hyperlink } from '@Green-Dot-Corporation/eureka-ui-typography';

import { useHref, useLinkClickHandler } from 'react-router-dom';

const NEW_WINDOW_TARGET = '_blank';

const RouteLink = ({
    onClick,
    shouldReplaceRoute = false,
    routeState,
    routeTarget,
    to,
    ...rest
}) => {
    const href = useHref(to);
    const linkClickHandler = useLinkClickHandler(to, {
        replace: shouldReplaceRoute,
        state: routeState,
        target: routeTarget,
    });

    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }

        const { defaultPrevented } = event ?? {};

        if (!defaultPrevented) {
            linkClickHandler(event);
        }
    };

    const shouldOpenInNewWindow = routeTarget === NEW_WINDOW_TARGET;

    return (
        <Hyperlink
            {...rest}
            href={href}
            onClick={handleClick}
            shouldOpenInNewWindow={shouldOpenInNewWindow}
        />
    );
};

RouteLink.propTypes = {
    onClick: PropTypes.func,
    shouldReplaceRoute: PropTypes.bool,
    routeState: PropTypes.object,
    routeTarget: PropTypes.string,
    to: PropTypes.string.isRequired,
};
RouteLink.defaultProps = {};

export default RouteLink;
